export default __webpack_public_path__ + "static/tierPlatnium-artboard-55-acd45124fbd234b63223b346cc37896a.png";